// THS Consultancy content — copy written for the redesign, inspired by thsconsultancy.com
export const COMPANY = {
  name: "THS Consultancy",
  domain: "thsconsultancy.com",
  url: "https://thsconsultancy.com",
  address: "124 City Road, London EC1V 2NX",
  email: "info@thsconsultancy.com",
  phone: "+44 7563 676358",
  linkedin: "https://www.linkedin.com/company/ths-consultancy-ltd/?originalSubdomain=uk",
  instagram: "https://www.instagram.com/thsconsultancy?igsi=MXA3MHAybnE1cWo2cQ==",
  facebook: "https://www.facebook.com/share/1CAZCHtqGz/",
};

export const HERO = {
  eyebrow: "Occupational Health & Safety Advisory · London",
  lines: ["Protecting people.", "Safeguarding", "the workplace."],
  paragraph:
    "THS Consultancy partners with organisations to control risk, achieve full regulatory compliance and build workplaces where every employee is protected. Strategy, inspection and training — delivered by seasoned OH&S advisors.",
};

export const METRICS = [
  { value: 25, suffix: "+", label: "Safety audits delivered" },
  { value: 5, suffix: "yrs", label: "Advising UK workplaces" },
];

export const PRACTICE_AREAS = [
  {
    id: "health-at-work",
    icon: "HeartPulse",
    title: "Promoting Health at Work",
    tagline: "Wellbeing as a competitive advantage",
    summary:
      "Healthier workforces are more productive. We build employee wellbeing programmes that protect mental and physical health while strengthening your culture and reputation.",
    image: "https://images.unsplash.com/photo-1623177623442-979c1e42c255",
    deliverables: [
      "Mental & physical health strategy",
      "Wellbeing programme design & rollout",
      "Productivity & absence optimisation",
      "Culture & reputation benchmarking",
    ],
    span: "lg:col-span-3",
  },
  {
    id: "workplace-hazards",
    icon: "ShieldAlert",
    title: "Workplace Hazards & Legal Compliance",
    tagline: "Manage risk. Meet the law.",
    summary:
      "A full sweep of physical and environmental hazards, matched with the legal requirements that govern them — then translated into clear, enforceable policies and procedures.",
    image: "https://images.pexels.com/photos/209719/pexels-photo-209719.jpeg?auto=compress&cs=tinysrgb&w=1200",
    deliverables: [
      "Physical & environmental hazard mapping",
      "Legal requirement gap analysis",
      "Policy & procedure formulation",
      "Compliance monitoring framework",
    ],
    span: "lg:col-span-3",
  },
  {
    id: "office-hazards",
    icon: "Armchair",
    title: "Office Hazards & Ergonomics",
    tagline: "The risks hiding in plain sight",
    summary:
      "Offices carry their own set of hazards. We identify them and give you practical and legal steps to resolve them — from ergonomic set-ups to display-screen assessments.",
    image: "https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd",
    deliverables: [
      "Office-specific risk identification",
      "Ergonomic workstation set-up",
      "Display screen equipment (DSE) reviews",
      "Practical & legal mitigation steps",
    ],
    span: "lg:col-span-2",
  },
  {
    id: "health-risks",
    icon: "Activity",
    title: "Health Risks at Work Assessment",
    tagline: "Find risk before it finds you",
    summary:
      "Every organisation carries health risks tied to its work activities. Our proactive assessments identify, monitor and report on them before they become incidents.",
    image: "https://images.pexels.com/photos/28506813/pexels-photo-28506813.jpeg?auto=compress&cs=tinysrgb&w=1200",
    deliverables: [
      "Proactive risk identification",
      "Occupational health monitoring",
      "Hazard reporting systems",
      "Exposure & control review",
    ],
    span: "lg:col-span-2",
  },
  {
    id: "equipment-safety",
    icon: "HardHat",
    title: "Equipment & Safe Working Practices",
    tagline: "Every tool, handled safely",
    summary:
      "Safe machinery operation, PPE provision and training, plus first-aid and emergency readiness — the operational backbone of a workplace that runs without incident.",
    image: "https://images.pexels.com/photos/3846183/pexels-photo-3846183.jpeg?auto=compress&cs=tinysrgb&w=1200",
    deliverables: [
      "Safe machinery operation protocols",
      "PPE provision & training",
      "First-aid procedures & training",
      "Emergency & evacuation readiness",
    ],
    span: "lg:col-span-2",
  },
];

export const ROADMAP = [
  {
    phase: "01",
    title: "On-Site Safety Inspection & Risk Assessment",
    body: "We begin by listening. A full on-site walkthrough and structured risk assessment surfaces every hazard — physical, environmental and procedural — with your people involved at every step.",
  },
  {
    phase: "02",
    title: "Policy Formulation & Legal Framework Setup",
    body: "Findings become action. We formulate company-specific policies and procedures mapped precisely to your legal obligations, giving you a defensible compliance framework.",
  },
  {
    phase: "03",
    title: "Employee PPE & Emergency Training Execution",
    body: "Protection is only real when people are equipped. We provide and train employees on PPE, first-aid and emergency procedures until safe practice becomes second nature.",
  },
  {
    phase: "04",
    title: "Continuous Incident Management & Audit Reporting",
    body: "Safety is never finished. We manage incident reporting, respond to concerns and deliver ongoing audits so your framework stays sharp, compliant and accident-free.",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Consultation is a two-way process",
    body: "It always begins with listening to the people at the workplace and allowing them to raise concerns. Real safety only happens when employees can influence the decisions that affect them.",
  },
  {
    n: "02",
    title: "The people doing the work know the risk",
    body: "Your employees are often the best placed to understand the hazards around them. We bring them into the room with managers — peace of mind and quality of work follow naturally.",
  },
  {
    n: "03",
    title: "Every worker has a right to a safe workplace",
    body: "All workers have the right to work in places where risks to their health and safety are properly controlled. We exist to make sure that right is upheld — every day, on every site.",
  },
];

// Field work photo gallery — swap these for the client's own site photos.
export const GALLERY = [
  { id: "g1", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/s1xqotfr_WhatsApp%20Image%202026-09-02%20at%2000.00.21.webp" },
  { id: "g2", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/ai4pmb5g_WhatsApp%20Image%202026-09-02%20at%2000.02.48.webp" },
  { id: "g3", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/xftvhsli_WhatsApp%20Image%202026-09-02%20at%2000.06.58.webp" },
  { id: "g4", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/7lcqibxm_WhatsApp%20Image%202026-09-02%20at%2000.18.29.jpeg" },
];

export const FOUNDER = {
  name: "Serdar Demirsoy",
  role: "Founder · Health & Safety Professional",
  linkedin: "https://www.linkedin.com/in/serdar-demirsoy",
  portrait:
    "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/wp9rxrnc_WhatsApp%20Image%202026-09-02%20at%2000.03.08.webp",
  credentials: [
    "NEBOSH International General Certificate",
    "IOSH Technical Membership",
    "Class C Occupational Health & Safety Specialist",
  ],
  bio: [
    "I am a Health and Safety professional who combines experience from both Turkey and the United Kingdom, with a strong focus on proactive risk management and developing a positive safety culture. Holding qualifications including the NEBOSH International General Certificate, IOSH Technical Membership, and Class C Occupational Health and Safety Specialist certification, I have experience in risk assessments, workplace health and safety inspections, employee awareness, and regulatory compliance.",
    "Through THS Consultancy, I aim to provide businesses with practical, sustainable, and effective health and safety solutions that go beyond simply meeting legal requirements. I believe that health and safety is not just about policies, procedures, and documentation; it is about effective risk management, building a strong safety culture, and creating a workplace where every employee can return home safely at the end of the day.",
  ],
};


export const COMPLIANCE = [
  "NEBOSH International General Certificate",
  "IOSH Technical Membership",
  "Class C Occupational Health & Safety Specialist",
  "CPD Certified Fire Marshall",
];

export const SITE_TYPES = ["Commercial Office", "Corporate Headquarters", "Industrial Site", "Warehouse / Logistics", "Other"];

// Client logos — shown as a left-to-right marquee near the gallery. First batch of 5.
export const CLIENTS = [
  { name: "Busy Beans", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/m8epfd7i_busy%20beans%20logo.webp" },
  { name: "Manor Springs Organic", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/skt091r5_manor%20springs%20logo.jpg" },
  { name: "Aytac Foods", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/vwfhcr3i_aytac%20logo.png" },
  { name: "Gardenia", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/3qzdi2yq_gardenia%20logo.jfif" },
  { name: "ARK Builders & Construction", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/qlkwj2ey_ark-logo.webp" },
  { name: "Ikra UK", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/g06mkfgc_ikra%20uk%20logo.jfif" },
  { name: "Kafkas Foods", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/83wv4zor_KAFKASlogo.png" },
  { name: "Xeden Energy, Construction & Renewables", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/io7pp8yf_XEdenECR_Logo.png" },
  { name: "Positive Power Solutions", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_hazard-defense-pro/artifacts/19hlaigl_Posotive%20Power%20Solutions%20Logo.webp" },
];
